<div class="rbac-modal-backdrop" *ngIf="open" (click)="onBackdropClick()">
  <div class="rbac-modal-panel" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
  </div>
</div>
